export default "<div class=\"loader\" *ngIf=\"isLoading\">Loading...</div>\r\n";